// examples:
// toTitleCase('APPLE. INC') => 'Apple. Inc'
// toTitleCase('TAIWAN SEMICONDUCTOR MANUFACTURING CO., LTD.') => 'Taiwan Semiconductor Manufacturing Co., Ltd.'
export const toTitleCase = (str: string) =>
  str
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
